import { AvatarWithRoomProps } from './avatar-with-room.types';
import { StyledAvatar, StyledAvatarWrapper, StyledRoomTitleWrapper, StyledLink, StyledRoomTitle } from './avatar-with-room.styles';
export const AvatarWithRoom = ({
  roomCode,
  avatar,
  roomTitle
}: AvatarWithRoomProps) => <StyledLink to={`/room/${roomCode}?auto-join=true`} data-sentry-element="StyledLink" data-sentry-component="AvatarWithRoom" data-sentry-source-file="avatar-with-room.tsx">
    <StyledAvatarWrapper data-sentry-element="StyledAvatarWrapper" data-sentry-source-file="avatar-with-room.tsx">
      <StyledAvatar src={avatar} alt="" data-sentry-element="StyledAvatar" data-sentry-source-file="avatar-with-room.tsx" />
      <StyledRoomTitleWrapper data-sentry-element="StyledRoomTitleWrapper" data-sentry-source-file="avatar-with-room.tsx">
        <StyledRoomTitle data-sentry-element="StyledRoomTitle" data-sentry-source-file="avatar-with-room.tsx">{roomTitle}</StyledRoomTitle>
      </StyledRoomTitleWrapper>
    </StyledAvatarWrapper>
  </StyledLink>;